const PaymentNotice = () => {
  return (
    <div className="gceo-payment-notice">
      <p className="gceo-payment-text">
        Payment of mock fees by individual students constitutes illegal
        collection.
      </p>
    </div>
  );
};

export default PaymentNotice;
